// src/utils/firstAllowedRoute.js
export const routePermissions = {
  '/tickets'       : 'tickets_view',
  '/instagram'     : 'instagram_manage',
  '/live-chat'     : 'live_chat_manage',
  '/playlist'      : 'playlist_manage',
  '/media-converter': 'media_converter_manage',
  '/survey-analytics': 'survey_analytics_view',
  '/activities'      : 'activities_view',
  '/dashboard'     : 'live_view',
  '/add-program'   : 'programs_create',
  '/add-person'    : 'people_create',
  '/add-qualification': 'qualifications_create',
  '/add-schedule'  : 'schedulings_create',
  '/add-topic'     : 'topics_create',
  '/prerolls'      : 'prerolls_view',
  '/prerolls-ext'  : 'prerolls_view',
  // '/skin': 'live_view',
}

// ordine di preferenza del landing
export const landingOrder = [
  '/tickets',          // mettiamo Tickets per primo: chi ha solo questo va diretto lì
  '/instagram',        // stesso principio: un instagrammer puro atterra qui
  '/live-chat',        // moderatore live: atterra qui se ha solo questo
  '/playlist',         // playlister: atterra qui se ha solo questo
  '/media-converter',  // converter: atterra qui se ha solo questo
  '/survey-analytics', // analisi del sondaggio Radio Radio 2026
  '/activities',       // auditor attività dashboard
  '/dashboard',
  '/prerolls',
  '/prerolls-ext',
  '/add-program',
  '/add-person',
  '/add-qualification',
  '/add-schedule',
  '/add-topic',
]

export function getFirstAllowedRoute(hasPermission) {
  for (const path of landingOrder) {
    const perm = routePermissions[path]
    if (!perm) return path
    if (hasPermission(perm) || hasPermission(`${perm}_own`)) return path
  }
  // fallback
  return '/login'
}
